import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Si tu entorno de React utiliza este archivo como punto de entrada,
// es vital que se mantenga limpio y solo llame a ReactDOM.createRoot.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);